import { atom } from "recoil"
import { ATOMS_KEYS } from "../atom-keys"
import { IResultGetUserDetail } from "src/services/home/getUserDetail/types"
export const subscriptionPlanNameStore = atom<
	IResultGetUserDetail["subscriptionPlanName"]
>({
	key: ATOMS_KEYS.SUBSCRIPTIONPLANNAME,
	default: undefined,
})
